var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _polyline, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _circle, _rect13, _rect14, _rect15, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRevenueGraphColour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vector",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3f3f3;}.cls-2{fill:#2a52c3;}.cls-3{fill:#de8e68;}.cls-4{fill:#56cad8;}.cls-5{fill:#74d5de;}.cls-6{fill:#fcc486;}.cls-7{fill:#fed385;}.cls-8{fill:#fed892;}.cls-9{fill:#dfdfdf;}.cls-10{fill:#f9f9f9;}.cls-11{fill:#fff;}.cls-12{fill:#d37c59;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 594.8,
    y: 89.22,
    width: 480.22,
    height: 697.59
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107,
    y: 941.6,
    width: 143.78,
    height: 170.94
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 292.79,
    y: 812.29,
    width: 143.78,
    height: 300.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 478.57,
    y: 663.58,
    width: 143.78,
    height: 448.97
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 345.68,
    y: 825.08,
    width: 16.7,
    height: 12.24
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 528.89,
    y: 666.78,
    width: 16.7,
    height: 12.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M459.19,476.9c10,0,90.23,11.33,125.33,29.36-4.83,23.51-36.39,162-36.39,162H528.48s-7.4-116.59-9-115.62c-10.63,5.47-52.82,19.27-97.91,19.94"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "459.19 476.9 363 826.69 345.68 826.69 345.68 476.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M477,329.89c4.85,2.11,21.47,16,24.44,21C528.58,317.1,573.34,283,577,279.06s4.8-25.89,4.8-30.69,6.62-17.59,13-17.59v57.55s-74.9,105.05-87.23,105.05c-8,0-47.51-17.36-53-22.61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M416,310.55c9.88-16,67,8.78,67,16.43s-21.18,42.88-30.67,42.38C444.77,369,405.77,327.16,416,310.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M402.13,287.34c72.58,0,68.52,180.72,57.06,189.56s-105.52,13.13-114.12,0S333.14,287.34,402.13,287.34Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M323.63,344.39c-12.89,4.05-46.05,66.57-46.05,76.11,0,20,67.52,108.09,76.11,108.09,3.58-6.21,9.31-19.09,9.31-19.09s-40.56-75.64-48-85.42c6.44-6,29.82-37.46,33.64-47.24s2.39-30.78,2.39-30.78Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M369.94,306.68c16.46,9-5.25,67.32-12.89,67.8s-43.93-18.91-43.93-28.41C313.12,338.43,352.82,297.29,369.94,306.68Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "345.68 834.73 345.68 849.53 390.28 849.53 390.28 844.16 363.2 834.73 345.68 834.73"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "528.16 677.67 528.16 692.47 572.77 692.47 572.77 687.11 545.69 677.67 528.16 677.67"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 594.8,
    y: 89.22,
    width: 480.22,
    height: 44.93
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 705.7,
    y: 190.74,
    width: 403.3,
    height: 114.91
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 729.25,
    y: 212.98,
    width: 360.56,
    height: 10.41
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 729.25,
    y: 237.78,
    width: 360.56,
    height: 10.41
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 729.25,
    y: 262.59,
    width: 360.56,
    height: 10.41
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 705.7,
    y: 351.83,
    width: 403.3,
    height: 114.91
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 759.42,
    cy: 409.28,
    r: 34.22
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 818.89,
    y: 375.06,
    width: 262.55,
    height: 33.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 818.89,
    y: 419.38,
    width: 262.55,
    height: 12.16
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 641.74,
    y: 516.58,
    width: 378.79,
    height: 186.36
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M420.14,251.78H391.39v40.79c0,10.13,28.75,10.3,28.75,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M441.15,233.08c-5.06-21.67-21.15-36.43-35.94-33-12.67,3-20.26,18.32-19,36.29a9.42,9.42,0,0,0,2.6,18.47,9.74,9.74,0,0,0,1.72-.17c6.86,16.52,20.41,26.81,33,23.87C438.32,275.11,446.21,254.74,441.15,233.08Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M393.55,243.21c3.78,0,4.44-5.22,4.44-9.85,0-6.2,5.89-11.8,9.52-12.86,6.57-1.9,9.92-2.34,13.9-4.5s8.72-5.41,8.72-5.41a55.65,55.65,0,0,1,4.79,6.73c3.65-1,22.77-5.56,22.77-19.26,0-9-7.56-10.18-11-13-3.66-3-2.09-12.07-12-12.07-8.88,0-13.25,9.33-18.93,12.92-6.87,4.35-20.35.85-29.23,10-4.31,4.44-5.32,15.37-8,19.37-3.66,5.42-10,7-10,15.27,0,6.07,5.15,16.32,11.35,17.82,0-6,2.19-11.74,6.63-11.74C391.34,236.63,388,243.21,393.55,243.21Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueGraphColour);
export default __webpack_public_path__ + "static/media/revenue-graph-colour.df2aa6740707aa6ed94aa7085d860455.svg";
export { ForwardRef as ReactComponent };